"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderwritingReviewFieldMapping = exports.UnderwritingReviewFieldName = void 0;
var UnderwritingReviewFieldName;
(function (UnderwritingReviewFieldName) {
    UnderwritingReviewFieldName["underwritingReviewRequiredID"] = "underwritingReviewRequiredID";
    UnderwritingReviewFieldName["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    UnderwritingReviewFieldName["check"] = "check";
    UnderwritingReviewFieldName["discloser"] = "discloser";
    UnderwritingReviewFieldName["checkUpdatedToFailTimestamp"] = "checkUpdatedToFailTimestamp";
    UnderwritingReviewFieldName["checkUpdatedToPassTimestamp"] = "checkUpdatedToPassTimestamp";
    UnderwritingReviewFieldName["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
})(UnderwritingReviewFieldName = exports.UnderwritingReviewFieldName || (exports.UnderwritingReviewFieldName = {}));
var UnderwritingReviewFieldMapping;
(function (UnderwritingReviewFieldMapping) {
    UnderwritingReviewFieldMapping["underwritingReviewRequiredID"] = "underwritingReviewRequiredID";
    UnderwritingReviewFieldMapping["cmhcLoanAccountNumber"] = "cmhcLoanAccountNumber";
    UnderwritingReviewFieldMapping["check"] = "check";
    UnderwritingReviewFieldMapping["discloser"] = "discloser";
    UnderwritingReviewFieldMapping["checkUpdatedToFailTimestamp"] = "checkUpdatedToFailTimestamp";
    UnderwritingReviewFieldMapping["checkUpdatedToPassTimestamp"] = "checkUpdatedToPassTimestamp";
    UnderwritingReviewFieldMapping["recordUpdatedTimestamp"] = "recordUpdatedTimestamp";
})(UnderwritingReviewFieldMapping = exports.UnderwritingReviewFieldMapping || (exports.UnderwritingReviewFieldMapping = {}));
